<template>
  <div :class="{ active: isActive }" ref="menu" v-if="items.length">
    <BurgerMenu :isActive="isActive" class="burger" @toggle="toggleMenu" />
    <div class="menu" v-if="isActive">
      <ul class="menu__list">
        <MenuItemComponent v-for="item in items" :key="item.id" :item="item" @closeMenu="closeMenu" />
      </ul>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  import BurgerMenu from '@/components/buttons/BurgerMenu.vue';

  import { MENU_ACTIONS_NAME, MENU_GETTERS_NAME } from '../store/menu/name';
  import MenuItemComponent from './MenuItemComponent.vue';

  export default {
    name: 'MenuComponent',
    components: {
      BurgerMenu,
      MenuItemComponent,
    },
    data() {
      return {
        isActive: false,
        items: [],
      };
    },
    created() {
      this.loadMenu();
    },
    methods: {
      ...mapActions({
        getMenu: MENU_ACTIONS_NAME.getMenu,
      }),
      loadMenu() {
        this.getMenu().then(() => {
          this.items = this.menu;
          this.setExpanded(this.items);
        });
      },
      setExpanded(items) {
        if (items)
          items.forEach((x) => {
            this.setExpanded(x.items);
            x.expanded = x.items.some((it) => it.url?.trim() === this.$route.path.trim() || it.expanded);
          });
      },
      getIsExpanded(item) {
        let isExpanded = item.items.some((it) => it.url?.trim() === this.$route.path.trim());
        if (!isExpanded && item.items.length > 0) isExpanded = item.items.some((it) => this.getIsExpanded(it));
        return isExpanded;
      },
      toggleMenu() {
        this.isActive ? this.closeMenu() : this.openMenu();
      },
      openMenu() {
        this.isActive = true;
        document.body.classList.add('active-left-menu');
        window.addEventListener('click', this.handlerClickOutside);
      },
      closeMenu() {
        this.isActive = false;
        document.body.classList.remove('active-left-menu');
        window.removeEventListener('click', this.handlerClickOutside);
      },
      handlerClickOutside(e) {
        if (!this.$refs.menu.contains(e.target)) {
          this.closeMenu();
        }
      },
    },
    watch: {
      menu(newMenu) {
        this.items = newMenu;
        this.setExpanded(this.items);
      },
    },
    computed: {
      ...mapGetters({
        menu: MENU_GETTERS_NAME.getMenu,
      }),
    },
  };
</script>

<style scoped lang="scss">
  @import '@/assets/theme/default/colors.scss';

  .menu {
    padding: 8px 16px 24px;

    &,
    :deep(.menu__root-item),
    :deep(a.menu__root-item-link),
    :deep(.menu__root-item-name) {
      color: $white;
      text-decoration: none;
      font-family: 'Fira Sans', sans-serif;
    }

    :deep(.menu__item .active-link) {
      color: #acdae8;
    }

    &__list {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }
  }
</style>
